/**
 * Created by mauget on 1/20/16.
 */

import { Model } from 'backbone';
import Immutable from 'immutable';

class LayoutMenuModel extends Model {

    initialize() {
    	this.set({
    		undoText: '',
    		undoFlag: false,
    		redoText: '',
    		redoFlag: false,
            hideGrid: false,
            designerNonVisualObjects:false,
            designerObjectMarkers:false,
            designerWorkflowMarkers:false,
            designerSnapToGrid:false,
            designerSnapTextToNeighbor:false,
            designerToolbar:false,
            designerPropertyBar:false
    	});
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

const layoutMenuModel = new LayoutMenuModel();
export default layoutMenuModel;

